// 表情与开关选项相关的常量

// 表情下拉选项（value 会保存并下发给设备）
export const emotionOptions = [
  { value: 'curious', label: '好奇 🧐' },
  { value: 'winking', label: 'wink 😉' },
  { value: 'shy', label: '害羞 😳' },
  { value: 'surprised', label: '吃惊 😲' },
  { value: 'side_eye', label: '斜视 😒' },
  { value: 'smiling', label: '微笑 😊' },
  { value: 'confident', label: '自信 😎' },
  { value: 'observing', label: '观察 👀' },
  { value: 'sleepy', label: '打瞌睡 😴' },
  { value: 'dreamy', label: '迷离 😵‍💫' },
  { value: 'teasing', label: '挑逗 😏' }
]

// 表情状态选项
export const emotionStateOptions = [
  { label: '开启', value: true },
  { label: '关闭', value: false }
]

// 背景动作状态选项
export const backgroundActionStateOptions = [
  { label: '开启', value: true },
  { label: '关闭', value: false }
]
